import { FC } from 'react';
import { Box, Typography, Stack } from '@mui/material';

import { Divider } from './Divider';
import { StepBody } from './StepBody';


interface Props {
  step: Programs.ProgramStep;
}

export const StepContent: FC<Props> = ({ step }) => {
  return (
    <Stack spacing={3} alignItems="center">
      <Typography variant="h4" textAlign="center" fontSize={24}>
        {step.title}
      </Typography>
      {step.image && (
        <Box
          component="img"
          src={step.image}
          alt={step.title}
          sx={{
            width: '100%',
            maxWidth: 300,
            borderRadius: 2,
            objectFit: 'cover',
          }}
        />
      )}

      <Divider/>
      {step.subtitle && (
        <Typography variant="overline" textAlign="center" color="primary">
          {step.subtitle}
        </Typography>
      )}
      <StepBody body={step.bodyText}/>
      <Divider/>
    </Stack>
  );
};
